(function () {
  const COOKIE_NAME = 'early_access_sale';
  const COOKIE_VALUE = '1';
  const MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

  function setEligibilityCookie() {
    document.cookie = `${COOKIE_NAME}=${COOKIE_VALUE}; path=/; max-age=${MAX_AGE_SECONDS}; SameSite=Lax`;
  }

  function isLandingPage() {
    const handle = (window.themeVariables?.settings?.earlyAccessSale?.landingPageHandle || 'summer-sale')
      .replace(/^\/+|\/+$/g, '');
    const path = window.location.pathname.replace(/\/+$/, '');
    return path === `/pages/${handle}`;
  }

  function isUnlocked() {
    // Do not set cookie on the Locksmith password screen
    return !document.querySelector('#locksmith_passcode_form');
  }

  function maybeGrantAccess() {
    if (!window.themeVariables?.settings?.earlyAccessSale?.enabled) return;
    if (!isLandingPage()) return;
    if (!isUnlocked()) return;
    setEligibilityCookie();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeGrantAccess);
  } else {
    maybeGrantAccess();
  }

  // Locksmith may unlock without a full navigation in some setups
  document.addEventListener('locksmith:authenticated', maybeGrantAccess);
})();
